import { Button } from "@/components/ui/button";
import {
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from "@/components/ui/dialog";
import { Link, useRouteContext } from "@tanstack/react-router";

export function JoinModal() {
	const { club } = useRouteContext({ from: "__root__" });

	return (
		<DialogContent>
			<DialogHeader>
				<DialogTitle>Faça parte da comunidade {club.name}</DialogTitle>
			</DialogHeader>

			<div className="text-base-6 text-muted-foreground">
				Para completar essa ação, você precisa estar logado
			</div>

			<DialogFooter>
				<Link to="/login">
					<Button variant="ghost">Fazer Login</Button>
				</Link>

				<Link to="/cadastro">
					<Button>Criar Conta</Button>
				</Link>
			</DialogFooter>
		</DialogContent>
	);
}
